// 基础
/**
 * 品牌类型
 * @author Jerry <superzcj_001@163.com>
 * @since  2020-08-26 10:16:18
 * @prop {number} Private 1---自有品牌
 * @prop {number} Agency 2---代理品牌
 */
export var BrandType;
(function (BrandType) {
    /** 自有品牌 */
    BrandType[BrandType["Private"] = 1] = "Private";
    /** 代理品牌 */
    BrandType[BrandType["Agency"] = 2] = "Agency";
})(BrandType || (BrandType = {}));
/**
 * 品牌类型选项
 * @author Jerry <superzcj_001@163.com>
 * @since  2020-08-28 00:57:16
 */
export const BrandTypeOptions = [
    { label: '自有品牌', value: BrandType.Private },
    { label: '代理品牌', value: BrandType.Agency },
];
//# sourceMappingURL=brand.js.map